export default "/images/fc7750b9cf405fbf1520d0447e7702b5.avif";